import { render } from "./prosper-menu.vue?vue&type=template&id=38926200&scoped=true"
import script from "./prosper-menu.vue?vue&type=script&lang=js"
export * from "./prosper-menu.vue?vue&type=script&lang=js"

import "./prosper-menu.vue?vue&type=style&index=0&id=38926200&lang=scss&scoped=true"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38926200"]])

export default __exports__